module.exports = "<div class=lines> <md-card flex> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> </md-card> <md-card> <rkc-lines-table table-content=c.searchResult table-definition=c.tableDefinition></rkc-lines-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/lines/lines.html
 ** module id = 507
 ** module chunks = 0
 **/